import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.4.8_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_react-d_655531feb6f0bac0c439dd38a5e5664d/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["RefreshRouteOnSave"] */ "/vercel/path0/src/app/(frontend)/components/RefreshRouteOnSave/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackedLink"] */ "/vercel/path0/src/app/(frontend)/components/TrackedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideosCarousel"] */ "/vercel/path0/src/app/(frontend)/components/Videos/VideosCarousel.tsx");
